
import { capitalize, map } from 'es-toolkit/compat';
import protos from 'utils/protos';

const { Service } = protos;

export const ServiceOptions = map(Service.Type, (enumVal: number, enumString: string) => {
  return {
    key: enumString,
    label: capitalize(enumString),
    value: enumVal,
  };
}) as SelectOption[];
